






















































































































import { gridConfig } from '@core/config/grid.config';
import { ArticleGroupedRibbons, Headlines, Data as ArticleData, ArticleExtraContent } from '@root/modules/article/types/article';
import articleConfig from '@root/modules/article/config/article.config';

import articleScroll from '@root/views/article/utils/articleScrollHandler';
import getArticleRibbons from '@root/views/article/utils/getArticleRibbons';
// Article info section
import ArticleInfoNormalTemplate from '@root/views/article/components/info/ArticleInfoNormalTemplate.vue';
import ArticleInfoFullTemplate from '@root/views/article/components/info/ArticleInfoFullTemplate.vue';
import ArticleInfoSmallTemplate from '@root/views/article/components/info/ArticleInfoSmallTemplate.vue';
import ArticleAdultLayer from '@root/views/article/components/ArticleAdultLayer.vue';
import ArticleRibbons from '@root/views/article/components/ArticleRibbons.vue';

// Article body components
import ArticleBody from '@root/views/article/components/ArticleBody.vue';
import ArticleBodyMultipage from '@root/views/article/components/ArticleBodyMultipage.vue';
import ArticleCategoryHeadlinesSection from '@root/views/article/components/headlines/ArticleCategoryHeadlinesSection.vue';
import ArticleTopHeadlinesSection from '@root/views/article/components/headlines/ArticleTopHeadlinesSection.vue';
import ArticlePTHeadlinesSection from '@root/views/article/components/headlines/ArticlePTHeadlinesSection.vue';
import ArticleHeadlinesSection from '@root/views/article/components/headlines/ArticleHeadlinesSection.vue';
import ArticleHeadlinesSectionAlternative from '@root/views/article/components/headlines/alternative/ArticleHeadlinesSection.vue';
import ArticleRelatedHeadlinesSection from '@root/views/article/components/headlines/ArticleRelatedHeadlinesSection.vue';
import ArticleInfoSocial from '@root/views/article/components/info/ArticleInfoSocial.vue';
import AdFormBanner from '@ads/components/adForm/AdFormBanner.vue';
import getBannerKey from '@root/modules/ads/utils/getBannerKey';

interface Data {
  isAdultConfirmed: boolean;
  isMobileView: boolean;
  relatedArticlesSettings: {
    minParagraphsLength: number;
    afterParagraphPosition: number;
    articlesLimit: number;
    articlesInBodyLimit: number;
    endOfArticleBody: boolean;
  };
  disableMidCol: boolean;
  fontSize: number;
}

interface Methods {
  confirmAdult: () => void;
  handleSetFontSize: () => void;
  getKey: (params: Record<string, any>) => string;
}

interface Computed {
  isCrArticle: boolean;
  topSection: string;
  topFragmentsNumber: number;
  isAdultArticle: boolean;
  isIssue: boolean;
  isMultipage: boolean;
  contentCenterClass: Record<string, boolean>;
  articleRibbons: ArticleGroupedRibbons | null;
  disableAds: boolean;
  disabledAdsList: string[];
  adPlacements: Record<string, any>;
  contentAdPlacement: string;
  contentFallbackAdPlacement: string;
}

interface Props {
  article: ArticleData;
  headlines: Headlines | [];
  isArticleFetching: boolean;
}

const topSectionMapping: Record<string, string> = {
  default: 'ArticleInfoNormalTemplate',
  fullImage: 'ArticleInfoFullTemplate',
  smallImage: 'ArticleInfoSmallTemplate',
  wideImage: 'ArticleInfoNormalTemplate',
};

export default articleScroll.extend<Data, Methods, Computed, Props>({
  components: {
    ArticleInfoNormalTemplate,
    ArticleInfoFullTemplate,
    ArticleInfoSmallTemplate,
    ArticleBody,
    ArticleBodyMultipage,
    ArticleRelatedHeadlinesSection,
    ArticlePTHeadlinesSection,
    ArticleHeadlinesSection,
    ArticleHeadlinesSectionAlternative,
    ArticleCategoryHeadlinesSection,
    ArticleTopHeadlinesSection,
    ArticleAdultLayer,
    ArticleRibbons,
    ArticleInfoSocial,
    AdFormBanner,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
    headlines: {
      type: Array,
      required: true,
    },
    isArticleFetching: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isAdultConfirmed: false,
      isMobileView: false,
      relatedArticlesSettings: this.$channelConfig('page').article.component.relatedArticles,
      disableMidCol: this.$channelConfig('page').article.component.disableMidCol,
      fontSize: 1,
    };
  },
  computed: {
    isCrArticle() {
      const articles = this.$store.getters['article/getCrArticles'];

      return articles.find((article: number) => article === this.article.id);
    },
    topSection() {
      const template = this.$channelConfig('page').article.component.info.template || this.article.settings.articleTemplate;
      return topSectionMapping[template] || 'ArticleInfoNormalTemplate';
    },
    topFragmentsNumber() {
      const leadPosition = this.$channelConfig('page').article.component.info.leadPosition;
      return leadPosition === 'top' || this.topSection === 'ArticleInfoSmallTemplate' ? articleConfig.ads.first_position : 0;
    },
    isAdultArticle() {
      return this.article.settings['icon.adult'] || false;
    },
    isIssue() {
      return this.$store.getters['issue/isIssue'];
    },
    isMultipage() {
      return this.$store.getters['article/isMultipage'];
    },
    contentCenterClass() {
      return { 'C-content-center': this.article.banners.disableAds };
    },
    articleRibbons() {
      const articleExtraContent: ArticleExtraContent = this.$store.getters['article/getArticleExtraContent'];
      if (!(articleExtraContent && articleExtraContent.ribbons_data)) {
        return null;
      }
      const articleRibbons = getArticleRibbons(this.article, articleExtraContent.ribbons_data);
      return articleRibbons;
    },
    disableAds() {
      return this.article.banners.disableAds;
    },
    disabledAdsList() {
      return this.$store.getters['adForm/getDisabledAdsList'];
    },
    adPlacements() {
      const placements: Record<string, any> = this.$store.getters['adForm/getAdsPlacements'];

      return placements || {};
    },
    contentAdPlacement() {
      return (this.adPlacements.content && this.adPlacements.content.mid[0]) || null;
    },
    contentFallbackAdPlacement() {
      return (this.adPlacements.mobilecrarticle && this.adPlacements.mobilecrarticle.mid[0]) || null;
    },
  },
  mounted() {
    if (process.client) {
      const screenWidth = window.screen.width;
      this.isMobileView = screenWidth <= gridConfig.breakpoints.lg;
    } else {
      this.isMobileView = this.$ua && this.$ua.deviceType() === 'smartphone' && !this.$ua.isFromTablet();
    }

    this.$nextTick(() => {
      this.$emit('article-loaded', this.article.id);
    });
  },
  methods: {
    confirmAdult() {
      this.isAdultConfirmed = true;
    },
    handleSetFontSize() {
      this.fontSize = this.fontSize === 3 ? 1 : this.fontSize + 1;
    },
    getKey({ prefix, index }) {
      return getBannerKey({ prefix, route: this.$route, store: this.$store, index });
    },
  },
});
